import { updateDiscoveryRules } from '@process-advisor/process-miner/api/methods/discoveryRules/updateDiscoveryRules'
import { setDiscoveryRulesEdited } from '@process-advisor/process-miner/api/methods/discoveryRules/setDiscoveryRulesEdited'
import { saveDiscoveryChildDiscoveryRules} from '@process-advisor/process-miner/api/methods/discoveryRules/saveDiscoveryChildDiscoveryRules'
import { processDiscoveryRule } from '@process-advisor/process-miner/api/methods/discoveryRules/processDiscoveryRule';
import { downloadDiscoveryRule } from '@process-advisor/process-miner/api/methods/discoveryRules/downloadDiscoveryRule';
import { updateDiscoveryRuleDetail} from '@process-advisor/process-miner/api/methods/discoveryRules/updateDiscoveryRuleDetail'

export const discoveryRuleMethods = {
    updateDiscoveryRules,
    setDiscoveryRulesEdited,
    saveDiscoveryChildDiscoveryRules,
    processDiscoveryRule,
    downloadDiscoveryRule,
    updateDiscoveryRuleDetail
};
